const OPEN = new Set(['pending', 'confirmed', 'preparing', 'out_for_delivery']);
const HOUR = 3600 * 1000;

// Slot start (Eastern Time) → epoch ms, DST-safe.
export function slotStartMs(slot) {
  if (!slot?.date) return null;
  const [y, m, d] = slot.date.split('-').map(Number);
  const guess = Date.UTC(y, m - 1, d, Number(slot.hour));
  const asET = new Date(new Date(guess).toLocaleString('en-US', { timeZone: 'America/New_York' }));
  const asUTC = new Date(new Date(guess).toLocaleString('en-US', { timeZone: 'UTC' }));
  return guess - (asET - asUTC);
}

// Open + slot starts within 60 min, or is in progress (until slot end).
export function isDueSoon(order, now) {
  const start = slotStartMs(order.delivery_slot);
  return start != null && OPEN.has(order.status) && now >= start - HOUR && now < start + HOUR;
}

// Due-soon pinned first (soonest slot), then by mode. 'newest' keeps the existing list order.
export function sortOrders(orders, mode, now) {
  const pinned = orders.filter((o) => isDueSoon(o, now)).sort((a, b) => slotStartMs(a.delivery_slot) - slotStartMs(b.delivery_slot));
  let rest = orders.filter((o) => !isDueSoon(o, now));
  if (mode === 'delivery') {
    const slotted = rest.filter((o) => o.delivery_slot).sort((a, b) => slotStartMs(a.delivery_slot) - slotStartMs(b.delivery_slot));
    rest = [...slotted, ...rest.filter((o) => !o.delivery_slot)];
  }
  return pinned.concat(rest);
}
